export default __webpack_public_path__ + "static/13-80d83d3fb9ceeb5105103ace5e51488c.png";